export const CharacterVerify = {
  pattern: /[^\\\'\"\s]$/, // 使用正則表達式，限制字符不包含反斜杠、單引號、雙引號和空格。
  message: "Invalid character!!", // 驗證不通過時的錯誤提示信息。
};

export const CharacterVerifyEngNumOnly = {
  pattern: /^(?!.*[\s'\\"]$)[a-zA-Z0-9!#$%&()*+,-./:;<=>?@[\]^_`{|}~\s]+$/,
  message: "Invalid character (English and number only)!!",
};

export const IPV4Verify = {
  pattern: /^((0|1\d?\d?|2(\d?|[0-4]\d|5[0-5])|[3-9]\d?)\.){3}(0|1\d?\d?|2(\d?|[0-4]\d|5[0-5])|[3-9]\d?)$/,
  message: "Invalid IPv4!!",
};

export const IPV6Verify = {
  pattern:
    /^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)|::([\da−fA−F]1,4:)0,4((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|::([\da−fA−F]1,4:)0,4((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)|([\da−fA−F]1,4:)2:([\da−fA−F]1,4:)0,2((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|([\da−fA−F]1,4:)2:([\da−fA−F]1,4:)0,2((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)|([\da−fA−F]1,4:)4:((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|([\da−fA−F]1,4:)4:((25[0−5]|2[0−4]\d|[01]?\d\d?)\.)3(25[0−5]|2[0−4]\d|[01]?\d\d?)|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}|:((:[\da−fA−F]1,4)1,6|:)|:((:[\da−fA−F]1,4)1,6|:)|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)|([\da−fA−F]1,4:)2((:[\da−fA−F]1,4)1,4|:)|([\da−fA−F]1,4:)2((:[\da−fA−F]1,4)1,4|:)|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)|([\da−fA−F]1,4:)4((:[\da−fA−F]1,4)1,2|:)|([\da−fA−F]1,4:)4((:[\da−fA−F]1,4)1,2|:)|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?|([\da−fA−F]1,4:)6:|([\da−fA−F]1,4:)6:/,
  message: "Invalid IPv6!!",
};

export const IPV6DNSVerify = {
  pattern:
    /^((([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|(([0-9a-fA-F]{1,4}:){1}(:[0-9a-fA-F]{1,4}){1,6})|(::([0-9a-fA-F]{1,4}:){0,5}((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d))|(::([0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}))$/,
  message: "Invalid IPv6 DNS Server!!",
};

export const MacVerify = {
  pattern: /^([0-9a-fA-F]{2})(([/\s:][0-9a-fA-F]{2}){5})$/,
  message: "Invalid Mac!!",
};

export const MaskVerify = {
  pattern: /^((128|192)|2(24|4[08]|5[245]))(\.(0|(128|192)|2((24)|(4[08])|(5[245])))){3}$/,
  message: "Invalid!!",
};

export const NumberVerify = {
  pattern: /(^[0-9]{5,15}$)|(^\+?[0-9]{6,20}$)/,
  message: "Invalid Phone Number!!",
};

export const PrefixLenVerify = {
  pattern: /(^[0-9]{0,128}$)/,
  message: "Invalid Prefix Length!!",
};

export const CoordinateVerify = {
  pattern: /^[0-9]+(\.)[0-9]+(\,)+(\s*)[0-9]+(\.)[0-9]+$/,
  message: "Invalid Coordinate!!",
};

export const CharacterVerifyTelegramToken = {
  pattern: /^[0-9]+:[A-Za-z0-9_-]+$/,
  message: "Invalid Telegram Token!!",
};

export const CharacterVerifyTelegramChatID = {
  pattern: /^\S+$/,
  message: "Invalid Telegram Chat ID!!",
};

export const CharacterVerifySlackToken = {
  pattern: /^\S+$/,
  message: "Invalid Slack Token!!",
};

export const CharacterVerifySlackChannelID = {
  pattern: /^\S+$/,
  message: "Invalid Slack Channel ID!!",
};

export const CharacterVerifyDisableURL = {
  pattern: /^https:\/\/discord\.com\/api\/webhooks\/\S+$/,
  message: "Invalid Disable URL!!",
};

export const CharacterVerifyNtfyTopic = {
  pattern: /^\S+$/,
  message: "Invalid Ntfy Topic!!",
};

export const basicRequire = { required: true, message: "required!" };
